import React from "react" ;
import { ReactNode } from "react" ;
import ObservableState from "../utils/ObservableState" ;
import * as ui from "../native" ;
import ObservableComponent from "./ObservableComponent" ;
import BaseUIProps , { copyBaseUIProps } from "../native/ui/BaseUIProps" ;
import ObjectObservable from "../utils/ObjectObservable" ;
import CallData from "../classes/CallData" ;
import ResultStatus from "../classes/ResultStatus" ;
import EventBus from "../utils/EventBus" ;
import MaterialIcons from "../icons/MaterialIcons" ;
import User from "../models/User" ;
import IconButton from "./IconButton" ;
import CallInteraction from "../classes/CallInteraction" ;
import LeadUtils from "../classes/LeadUtils" ;
import Result from "../classes/Result" ;
import DurationView from "./DurationView" ;
import CallStatus from "../classes/CallStatus" ;
import TimeZoneUtil from "../classes/TimeZoneUtil" ;
import InteractionType from "../classes/InteractionType" ;
import TwilioClient from "../classes/TwilioClient" ;
import Lead from "../models/Lead" ;
import DateTime from "../core/DateTime" ;
import TextView from "./TextView" ;
import FailureMessage from "../classes/FailureMessage" ;
import Interaction from "../models/Interaction" ;
import IconView from "./IconView" ;
import { BuildContext } from "../classes/BuildContext" ;

type _CallButtonOnPressed = ( d3eState : RecentCallListTileRefs ) => void ;


  export  interface  RecentCallListTileProps extends  BaseUIProps {   key?: string ;
   interaction: Interaction ;
   client: TwilioClient ;
   data: CallData ;
   currentUser: User ;
 }
/// To store state data for RecentCallListTile 
   class  RecentCallListTileRefs {  public recentLeadButton: RecentLeadButtonState = new RecentLeadButtonState() ;
 }

   interface  RecentLeadButtonWithStateProps extends  BaseUIProps {   key?: string ;
   d3eState: RecentCallListTileRefs ;
   _onCallButtonPressed?: _CallButtonOnPressed ;
   data: CallData ;
   interaction: Interaction ;
 }

   class  RecentLeadButtonState extends  ObjectObservable {  private _hover: boolean = false ;
  public get hover (  ) : boolean {
 return this._hover ; 
 }
  public setHover ( val : boolean ) {
 let isValChanged :boolean=this._hover !== val;

if ( !isValChanged ) {
 return ; 
 }

this._hover=val;

this.fire('hover',this);
 }
 }

   class  _RecentLeadButtonWithState extends  ObservableComponent<RecentLeadButtonWithStateProps> {   static contextType = BuildContext ;
   context: React.ContextType<typeof BuildContext> ;
 public constructor ( props : RecentLeadButtonWithStateProps ) {
 super(props);

this.initState();
 }
  public get data (  ) : CallData {
 return this.props.data ; 
 }
  public get interaction (  ) : Interaction {
 return this.props.interaction ; 
 }
  public get recentLeadButton (  ) : RecentLeadButtonState {
 return this.props.d3eState.recentLeadButton ; 
 }
  public get d3eState (  ) : RecentCallListTileRefs {
 return this.props.d3eState ; 
 }
  public get _onCallButtonPressed (  ) : _CallButtonOnPressed {
 return this.props._onCallButtonPressed ; 
 }
  public initState (  ) {
 super.initState();

this.updateObservable('recentLeadButton',null,this.recentLeadButton);

this.initListeners();

this.enableBuild=true;
 }
  public initListeners (  ) : void {
 this.updateSyncProperty('data',this.props.data);

this.updateSyncProperty('interaction',this.props.interaction);

this.on([ 'data', 'data.deviceReady', 'interaction', 'interaction.callStatus', 'interaction.createdDate', 'interaction.duration', 'interaction.isIncoming', 'interaction.lead', 'interaction.lead.name', 'interaction.type', 'recentLeadButton', 'recentLeadButton.hover' ],this.rebuild);
 }
  public componentDidUpdate ( prevProps : RecentLeadButtonWithStateProps ) : void {
 super.componentDidUpdate(prevProps);

if ( prevProps.data !== this.props.data ) {
 this.updateObservable('data',prevProps.data,this.props.data);

this.fire('data',this);
 }

if ( prevProps.interaction !== this.props.interaction ) {
 this.updateObservable('interaction',prevProps.interaction,this.props.interaction);

this.fire('interaction',this);
 }
 }
  public recentLeadButtonOnEnter ( event ) : void {
 return this.recentLeadButton.setHover(true) ; 
 }
  public recentLeadButtonOnExit ( event ) : void {
 return this.recentLeadButton.setHover(false) ; 
 }
  public dispose (  ) : void {
 this.recentLeadButton.setHover(false);

super.dispose();
 }
  public render (  ) : ReactNode {
 let cStyle=this.context.theme;

return ui.Row({ mainAxisAlignment:ui.MainAxisAlignment.spaceBetween, crossAxisAlignment:ui.CrossAxisAlignment.center, states:ui.joinStates({ 'data-c0':this.recentLeadButton.hover },this.props.states), children:[ ui.Row({ mainAxisAlignment:ui.MainAxisAlignment.start, crossAxisAlignment:ui.CrossAxisAlignment.center, children:[ ui.Container({ decoration:new ui.BoxDecoration({color:ui.HexColor.fromHexStr(LeadUtils.getColorForFirstLetter(this.interaction.lead.name !== null ? this.interaction.lead.name : 'Unknown')),borderRadius:ui.BorderRadius.circular(20.0)}), alignment:ui.Alignment.center, child:TextView({ data:this.interaction.lead.name.isEmpty || this.interaction.lead.name === '' ? '' : this.interaction.lead.name [ 0 ].toUpperCase(), textAlign:ui.TextAlign.center, style:new ui.TextStyle({color:cStyle.c14,fontWeight:ui.FontWeight.bold}), className:'x290 hc vc' }), className:'x08e hc vc', key:'0' }), ui.Column({ mainAxisAlignment:ui.MainAxisAlignment.center, crossAxisAlignment:ui.CrossAxisAlignment.start, children:[ ui.Row({ mainAxisAlignment:ui.MainAxisAlignment.spaceBetween, children:[ TextView({ data:this.interaction.lead.name, key:'0' }) ], className:'x016 hc', key:'0' }), ui.Row({ children:[ IconView({ icon:!this.interaction.isIncoming ? MaterialIcons.call_made : this.interaction.isIncoming && this.interaction.callStatus === CallStatus.Unanswered ? MaterialIcons.call_missed : this.interaction.type === InteractionType.Voicemail ? MaterialIcons.voicemail : this.interaction.isIncoming ? MaterialIcons.phone_callback : MaterialIcons.call, size:16, states:ui.joinStates({ 'data-c1':this.interaction.isIncoming && this.interaction.callStatus === CallStatus.Unanswered, 'data-c2':this.interaction.type === InteractionType.Voicemail },{}), color:this.interaction.isIncoming && this.interaction.callStatus === CallStatus.Unanswered ? cStyle.c10 : this.interaction.type === InteractionType.Voicemail ? cStyle.c10 : null, className:'xdb5', key:'0' }), TextView({ data:this.interaction.type === InteractionType.Voicemail && this.interaction.isIncoming ? 'Incoming Voicemail' : this.interaction.type === InteractionType.Voicemail && !this.interaction.isIncoming ? 'Outgoing Voicemail' : this.interaction.isIncoming && this.interaction.callStatus === CallStatus.Unanswered ? 'Missed Call' : this.interaction.isIncoming ? 'Incoming Call' : 'Outgoing Call', states:ui.joinStates({ 'data-c2':this.interaction.isIncoming && this.interaction.callStatus === CallStatus.Unanswered },{}), style:new ui.TextStyle({color:this.interaction.isIncoming && this.interaction.callStatus === CallStatus.Unanswered ? cStyle.c10 : null}), className:'xa72', key:'1' }) ], key:'1' }) ], key:'1' }), ui.Container({ className:'xdc2 hc h', key:'2' }), ((this.interaction.duration !== null) ? DurationView({ value:this.interaction.duration, format:'hh mm ss' }) : [  ]), ui.Container({ className:'xe0f hc', key:'4' }), ((this.recentLeadButton.hover && this.data.deviceReady) ? IconButton({ icon:MaterialIcons.call, size:16, hoverColor:cStyle.c1, tooltip:'Call', onPressed:(  ) => {
 this._onCallButtonPressed(this.d3eState);
 }
 }) : [  ]), ui.Container({ className:'xa2c hc', key:'6' }), TextView({ data:(this.interaction !== null && this.interaction.createdDate !== null) ? TimeZoneUtil.chatMessageTimestamp(this.interaction.createdDate).toString() : '', className:'xbad', key:'7' }) ], className:'x7ce hc h', key:'0' }) ], onEnter:( event ) => {
 this.recentLeadButtonOnEnter(event);
 }
, onExit:( event ) => {
 this.recentLeadButtonOnExit(event);
 }
, className:ui.join('RecentCallListTile x600 hc h ' , this.props.className ?? ''), ...copyBaseUIProps(this.props,) }) ; 
 }
 }
function RecentLeadButtonWithState ( props : RecentLeadButtonWithStateProps ) {
 return React.createElement(_RecentLeadButtonWithState,props) ; 
 }


   class  _RecentCallListTileState extends  ObservableComponent<RecentCallListTileProps> {   static defaultProps = { interaction:null, client:null, data:null, currentUser:null } ;
   d3eState: RecentCallListTileRefs = new RecentCallListTileRefs() ;
   lastInteraction: Interaction = null ;
   lead: Lead = null ;
   static contextType = BuildContext ;
   context: React.ContextType<typeof BuildContext> ;
 public constructor ( props : RecentCallListTileProps ) {
 super(props);

this.initState();
 }
  public get interaction (  ) : Interaction {
 return this.props.interaction ; 
 }
  public get client (  ) : TwilioClient {
 return this.props.client ; 
 }
  public get data (  ) : CallData {
 return this.props.data ; 
 }
  public get currentUser (  ) : User {
 return this.props.currentUser ; 
 }
  public initState (  ) {
 super.initState();

this.initListeners();

this.enableBuild=true;
 }
  public initListeners (  ) : void {
 this.updateSyncProperty('interaction',this.props.interaction);

this.updateSyncProperty('data',this.props.data);

this.updateSyncProperty('currentUser',this.props.currentUser);

this.on([ 'interaction', 'interaction.lead' ],this.computeLead);

this.computeLead();

this.on([ 'data', 'interaction' ],this.rebuild);
 }
  public componentDidUpdate ( prevProps : RecentCallListTileProps ) : void {
 super.componentDidUpdate(prevProps);

if ( prevProps.interaction !== this.props.interaction ) {
 this.updateObservable('interaction',prevProps.interaction,this.props.interaction);

this.fire('interaction',this);
 }

if ( prevProps.client !== this.props.client ) {
 this.fire('client',this);
 }

if ( prevProps.data !== this.props.data ) {
 this.updateObservable('data',prevProps.data,this.props.data);

this.fire('data',this);
 }

if ( prevProps.currentUser !== this.props.currentUser ) {
 this.updateObservable('currentUser',prevProps.currentUser,this.props.currentUser);

this.fire('currentUser',this);
 }
 }
  public setLastInteraction ( val : Interaction ) : void {
 let isValChanged :boolean=this.lastInteraction !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateObservable('lastInteraction',this.lastInteraction,val);

this.lastInteraction=val;

this.fire('lastInteraction',this);
 }
  public setLead ( val : Lead ) : void {
 let isValChanged :boolean=this.lead !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateObservable('lead',this.lead,val);

this.lead=val;

this.fire('lead',this);
 }
  public computeLead  =  (  ) : void  =>  {
 try {
 this.setLead(this.interaction.lead);
 }
 catch ( exception ) {
 console.log(' exception in computeLead : ' + exception.toString());

this.setLead(null);
 }
 }
  public render (  ) : ReactNode {
 let cStyle=this.context.theme;

return RecentLeadButtonWithState({ d3eState:this.d3eState, _onCallButtonPressed:this.onCallButtonPressed, data:this.data, interaction:this.interaction, className:this.props.className ?? '', ...copyBaseUIProps(this.props,) }) ; 
 }
  public onCallButtonPressed  =  async  ( d3eState : RecentCallListTileRefs ) : Promise<void>  =>  {
 this.setLastInteraction(null);

if ( this.client.data.deviceReady ) {
 if ( this.currentUser.twilioNumber === null || this.currentUser.twilioNumber.isEmpty ) {
 EventBus.get().fire(new FailureMessage({ message:'You do not have a Twilio Number. Please contact your administrator.' }));

return ; 
 }

if ( this.lead.phone === null || this.lead.phone.isEmpty ) {
 EventBus.get().fire(new FailureMessage({ message:'Lead does not have valid phone number' }));

return ; 
 }

let hasMicPermission :boolean=( await this.client.checkMicPermission());

if ( !hasMicPermission ) {
 EventBus.get().fire(new FailureMessage({ message:'Please allow microphone permission to make calls.' }));

return ; 
 }

let connectCall :boolean=( await this.client.makeCall(this.currentUser.twilioNumber,this.lead.phone,this.lead.ext,{ onStatus:( s ) => {
 this.onStatusChange(s);
 }
, onFailure:( m,e ) => {
 this.onConnectionFailure(m,e);
 }
 }));
 }
 }
  public onStatusChange  =  async  ( status : string ) : Promise<void>  =>  {
 if ( this.lastInteraction === null ) {
 this.setLastInteraction(new Interaction({ lead:this.lead, fromNumber:this.currentUser.twilioNumber, toNumber:this.lead.phone, callStatus:CallStatus.Initiated, type:InteractionType.Call, sid:this.client.callSid, isIncoming:false, handledBy:this.currentUser }));

EventBus.get().fire(new CallInteraction({ interaction:this.lastInteraction, data:this.data, lead:this.lead }));

let result :Result<Interaction>=( await this.lastInteraction.save());

if ( result.status === ResultStatus.Success ) {
  }
 }
 else if ( this.lastInteraction !== null ) {
 let st :CallStatus=CallStatus.Initiated;

switch ( status ) {
 case 'ringing' : {
 st=CallStatus.Ringing;
 break; }

case 'completed' : {
 st=CallStatus.Completed;
 break; }

case 'accepted' : {
 {
 st=CallStatus.InProgress;

this.lastInteraction.setStartTime(DateTime.now());
 }
 break; }

case 'failed' : {
 st=CallStatus.Failed;
 break; }

case 'busy' : {
 st=CallStatus.Busy;
 break; }

case 'open' : {
 st=CallStatus.InProgress;
 break; }

case 'connecting' : {
 st=CallStatus.Connecting;
 break; }

case 'initiated' : {
 st=CallStatus.Initiated;
 break; }
 default: {
  }
 }

this.lastInteraction.setCallStatus(st);
 }
 }
  public onConnectionFailure  =  ( message : string,error : string ) : void  =>  {
 EventBus.get().fire(new FailureMessage({ message:message }));
 }
  public get recentLeadButton (  ) {
 return this.d3eState.recentLeadButton ; 
 }
 }
export default function RecentCallListTile ( props : RecentCallListTileProps ) {
 return React.createElement(_RecentCallListTileState,{ ..._RecentCallListTileState.defaultProps, ...props }) ; 
 }
